import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=379b0aee&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=379b0aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b0aee",
  null
  
)

export default component.exports